import FVector from '@data/geometry/FVector';
import { SensorPoint } from 'Simulations/SensorPoint';

/**
 * @deprecated we should stop using that class. Instead, we should create a new i
 */
export default class Grid {
    constructor() {}

    static SITE_ANALYSIS = 0;
    static LAND_ANALYSIS = 1;

    static sensorPointsN: number = 0;
    static LAND = false;
    static analysisType = Grid.SITE_ANALYSIS;
    static gridRes: number = 0; // Resolution of the sensor points
    static gridOrigin = new FVector(); // Origin of the rectangle
    static gridX: number = 0;
    static gridY: number = 0;
    static gridZ: number = 0; // Length of the grid's X,Y,Z dimension
    static maxFloor: number = 0;
    static siteVolumeCenter: FVector = new FVector(); // Grid center
    static boundingBox: FVector[] = new Array(4).fill(null).map(() => new FVector());

    static gridAngle: number = 0;
    static sensorPoints: SensorPoint[];
    static firstActiveID = 0;
    static centers: FVector[] | null = null;
    static siteLat: number = 0;
    static siteLon: number = 0;
    static siteAlt: number = 0;

    static analysisArea: Map<string, number[]> = new Map();
    static legalBorder: Map<string, number[]> = new Map();
    static buildableBorder: Map<string, number[]> = new Map();

    static legalBorderArea: number;

    static outsideSwiss = false;
    static METRICcode = 2056;
    static WGS84code = 4326;

    static allGridPositions: FVector[] = [];
    static notNullSensorPoints: SensorPoint[] = [];

    static getCenters(): FVector[] {
        if (Grid.centers == null) {
            Grid.centers = [];
            for (let i = 0; i < Grid.sensorPoints.length; i++) {
                if (Grid.sensorPoints[i].ID === -1) continue;
                Grid.centers.push(Grid.sensorPoints[i].getCenter());
            }
        }
        return Grid.centers;
    }

    static getPoints() {
        return Grid.getBorderPoints(Grid.analysisArea, 'AnalysisArea');
    }

    static getBuildableBorderPoints() {
        return Grid.getBorderPoints(Grid.buildableBorder, 'BuildableBorder');
    }

    private static getBorderPoints(border: Map<string, number[]>, label: string) {
        const x = border.get('x') || [];
        const y = border.get('y') || [];
        const z = border.get('z') || [];

        if (x.length !== y.length || y.length !== z.length) throw new Error(`${label} coordinate arrays must have the same length`);

        const points: FVector[] = [];

        for (let i = 0; i < x.length; i++) {
            points.push(new FVector(x[i], y[i], z[i]));
        }

        return points;
    }

    static indexToXYZ(i: number): [number, number, number] {
        let x = Math.floor(i / (Grid.gridZ * Grid.gridY));
        let y = Math.floor(i / Grid.gridZ) % Grid.gridY;
        let z = i % Grid.gridZ;
        return [x, y, z];
    }

    static xyzToIndex(x: number, y: number, z: number): number {
        if (x < 0 || x > Grid.gridX) console.warn('X is not in range of GridX', x, Grid.gridX);
        if (y < 0 || y > Grid.gridY) console.warn('Y is not in range of GridY', y, Grid.gridY);
        if (z < 0 || z > Grid.gridZ) console.warn('Z is not in range of GridZ', z, Grid.gridZ);
        return z + Grid.gridZ * y + Grid.gridY * Grid.gridZ * x;
    }

    static printInfo() {
        console.log('sensorPointsN: ' + Grid.sensorPointsN);
        console.log('LAND: ' + Grid.LAND);
        console.log('gridRes: ' + Grid.gridRes);
        console.log('gridOrigin: ' + Grid.gridOrigin);
        console.log('gridX: ' + Grid.gridX);
        console.log('gridY: ' + Grid.gridY);
        console.log('gridZ: ' + Grid.gridZ);
        console.log('siteVolumeCenter: ' + Grid.siteVolumeCenter);
        console.log('boundingBox: ' + JSON.stringify(Grid.boundingBox));
        console.log('gridAngle: ' + Grid.gridAngle);
        console.log('sensorPoints: ', Grid.sensorPoints);
        //  console.log("mapIndexToID: " + JSON.stringify(Array.from(Grid.mapIndexToID.entries())));
        console.log('siteLat: ' + Grid.siteLat);
        console.log('siteLon: ' + Grid.siteLon);
        console.log('siteAlt: ' + Grid.siteAlt);
        console.log('x: ' + JSON.stringify(Grid.analysisArea.get('x')));
        console.log('y: ' + JSON.stringify(Grid.analysisArea.get('y')));
        console.log('z: ' + JSON.stringify(Grid.analysisArea.get('z')));
        console.log('perimeterX: ' + JSON.stringify(Grid.legalBorder.get('x')));
        console.log('perimeterY: ' + JSON.stringify(Grid.legalBorder.get('y')));
        console.log('perimeterZ: ' + JSON.stringify(Grid.legalBorder.get('z')));
        console.log('outsideSwiss: ' + Grid.outsideSwiss);
        console.log('EPSGcode: ' + Grid.METRICcode);
    }

    static xyzToIndexArray(xyz: [number, number, number]): number {
        return Grid.xyzToIndex(xyz[0], xyz[1], xyz[2]);
    }

    static mapIndexToID(index: number) {
        return Grid.sensorPoints[index].ID;
    }
}
